export const fr = {
  nav: {
    home: 'Accueil',
    treatments: 'Traitements',
    results: 'Résultats',
    gallery: 'Galerie',
    compare: 'Comparer',
    blog: 'Blog',
    locations: 'Emplacements',
    contact: 'Contact',
    bookConsultation: 'Consultation Gratuite',
    hairAnalysis: 'Analyse IA des Cheveux',
  },
  hairTransplant: {
    title: 'Greffe de Cheveux FUE',
    subtitle: 'Extraction d\'unités folliculaires avancée visant des résultats naturels et durables. Les résultats individuels varient.',
    bookConsultation: 'Réserver une Consultation',
    viewResults: 'Voir les Résultats',
    benefits: 'Pourquoi Choisir la Greffe FUE?',
    process: 'La Procédure FUE Étape par Étape',
    pricing: 'Forfaits à Prix Transparents',
    stats: 'Nos Résultats',
  },
  stemcellTherapy: {
    title: 'Thérapie par Cellules Souches',
    subtitle: 'Contenu informatif sur la recherche autour des cellules souches en restauration capillaire. La disponibilité dépend d\'une évaluation médicale et de la réglementation locale.',
    benefits: 'Avantages de la Thérapie par Cellules Souches',
    howItWorks: 'Comment Ça Marche',
    pricing: 'Forfaits de Thérapie par Cellules Souches',
    idealFor: 'Qui Devrait Considérer la Thérapie par Cellules Souches?',
  },
  prp: {
    title: 'Traitement PRP Capillaire',
    subtitle: 'Thérapie au plasma riche en plaquettes pour stimuler la croissance naturelle des cheveux',
    whatIs: 'Qu\'est-ce que le Traitement PRP?',
    benefits: 'Avantages du Traitement PRP',
    procedure: 'La Procédure PRP',
    packages: 'Forfaits de Traitement PRP',
    results: 'Quand Attendre des Résultats',
    idealFor: 'Qui Devrait Considérer le PRP?',
  },
  hero: {
    title: 'Greffes de Cheveux Expertes en Europe',
    subtitle: 'Expertise chirurgicale turque associée à des standards de suivi européens. Nous proposons des interventions FUE et DHI. Les résultats individuels varient selon l\'aptitude, la technique et le suivi.',
    bookConsultation: 'Réserver une Consultation',
    whatsapp: 'WhatsApp',
  },
  services: {
    title: 'Nos Services Premium de Restauration Capillaire',
    subtitle: 'Techniques avancées combinant expertise turque et normes de qualité européennes',
  },
  results: {
    title: 'Exemples de Patients et Calendrier Prévu',
    subtitle: 'Exemples illustratifs issus de patients précédents. Les résultats individuels varient selon la zone donneuse, le schéma de perte, la santé, la technique et le suivi.',
  },
  locations: {
    title: 'Emplacements Pratiques à Travers l\'Europe',
    subtitle: 'Soins premium dans des installations ultramodernes',
  },
  contact: {
    title: 'Commencez Votre Parcours de Restauration Capillaire',
    subtitle: 'Réservez votre consultation gratuite aujourd\'hui',
    name: 'Nom Complet',
    email: 'Email',
    phone: 'Téléphone',
    treatment: 'Intéressé Par',
    message: 'Parlez-nous de vos préoccupations capillaires',
    send: 'Envoyer',
    sending: 'Envoi...',
  },
  footer: {
    about: 'Hair Art Clinics combine l\'excellence médicale turque avec les normes de qualité européennes, offrant des services premium de restauration capillaire via nos cliniques partenaires en Turquie, avec advies vanuit La Haye, aux Pays-Bas.',
    quickLinks: 'Liens Rapides',
    contactInfo: 'Informations de Contact',
    followUs: 'Suivez-Nous',
    rights: 'Tous droits réservés.',
  },
  treatments: {
    categories: {
      hairTransplant: 'Techniques de Greffe Capillaire',
      facialHair: 'Restauration Capillaire Faciale',
      revision: 'Révision et Correction',
      nonSurgical: 'Traitements Non Chirurgicaux',
      additional: 'Services Additionnels',
      guides: 'Informations et Guides'
    },
    bookConsultation: 'Réserver Consultation Gratuite',
    benefits: 'Avantages',
    procedure: 'Procédure',
    recovery: 'Chronologie de Récupération',
    pricing: 'Tarification',
    faq: 'Questions Fréquemment Posées',
    contraindications: 'Contre-indications',
    beforeAfter: 'Résultats Avant & Après',
    before: 'Avant',
    after: 'Après',
    bookingSubtitle: 'Planifiez votre consultation gratuite avec nos experts',
    preferredDate: 'Date Préférée',
    selectDate: 'Sélectionner une date',
    bookingMessage: 'Parlez-nous de vos préoccupations capillaires et de vos questions',
    submitBooking: 'Soumettre la Demande de Réservation',
    bookingSuccess: 'Merci! Nous vous contacterons sous peu pour confirmer votre rendez-vous.',
    category: 'Catégories de Traitement',
    all: 'Tous les Traitements',
    gallery: 'Galerie Avant/Après',
    resultsTitle: 'Nos Vrais Résultats',
    resultsSubtitle: 'Découvrez les histoires de transformation de milliers de nos patients satisfaits',
    patientStories: 'Histoires de Patients',
    viewDetails: 'Voir les Détails',
    grafts: 'greffons',
    age: 'Âge',
    testimonial: 'Témoignage du Patient',
    allResults: 'Tous les Résultats',
    filterByProcedure: 'Filtrer par Procédure'
  },
  comparison: {
    title: 'FUE vs DHI vs Sapphire FUE',
    subtitle: 'Comparez les techniques de greffe capillaire pour trouver la méthode parfaite pour vous',
    compareTitle: 'Comparaison des Techniques',
    method: 'Méthode',
    duration: 'Durée de la Procédure',
    recovery: 'Temps de Récupération',
    scarring: 'Cicatrisation',
    density: 'Densité Capillaire',
    pain: 'Niveau de Douleur',
    cost: 'Fourchette de Prix',
    bestFor: 'Idéal Pour',
    fue: {
      name: 'FUE',
      duration: '6-8 heures',
      recovery: '7-10 jours',
      scarring: 'Micro-points minimaux',
      density: 'Élevée',
      pain: 'Faible (anesthésie locale)',
      cost: '€2,500 - €4,500',
      bestFor: 'Grandes zones, maximum de greffons'
    },
    dhi: {
      name: 'DHI',
      duration: '8-10 heures',
      recovery: '5-7 jours',
      scarring: 'Presque inexistante',
      density: 'Très Élevée',
      pain: 'Minimale',
      cost: '€3,500 - €5,500',
      bestFor: 'Travail de précision, conception de ligne capillaire'
    },
    sapphire: {
      name: 'Sapphire FUE',
      duration: '6-8 heures',
      recovery: '5-7 jours',
      scarring: 'Minimale',
      density: 'Très Élevée',
      pain: 'Faible',
      cost: '€3,000 - €5,000',
      bestFor: 'Résultats naturels, guérison rapide'
    },
    advantages: 'Avantages Clés',
    disadvantages: 'Considérations',
    faqTitle: 'Questions Fréquemment Posées'
  },
  blog: {
    title: 'Blog Santé et Soins Capillaires',
    subtitle: 'Conseils d\'experts, informations sur les traitements et témoignages de patients',
    categories: {
      all: 'Tous les Articles',
      hairHealth: 'Santé Capillaire',
      treatmentInfo: 'Informations sur les Traitements',
      patientStories: 'Témoignages de Patients',
      clinicGuides: 'Guides Cliniques',
      procedures: 'Procédures'
    },
    readMore: "Lire l'article complet",
    backToBlog: 'Retour au Blog',
    recentPosts: 'Articles Récents',
    relatedPosts: 'Articles Connexes',
    publishedOn: 'Publié le',
    by: 'par',
    views: 'vues',
    noPostsFound: 'Aucun article trouvé',
    searchPlaceholder: 'Rechercher des articles...',
    admin: {
      title: 'Gestion du Blog',
      newPost: 'Nouvel Article',
      editPost: 'Modifier l\'Article',
      deletePost: 'Supprimer l\'Article',
      published: 'Publié',
      draft: 'Brouillon',
      title_label: 'Titre',
      slug_label: 'Slug URL',
      category_label: 'Catégorie',
      excerpt_label: 'Extrait',
      content_label: 'Contenu',
      featuredImage_label: 'URL de l\'Image',
      isPublished_label: 'Publier',
      save: 'Enregistrer',
      cancel: 'Annuler',
      deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet article?',
      viewOnSite: 'Voir sur le Site'
    }
  },
  error: "Erreur",
  success: "Succès",
  admin: {
    dashboard: 'Tableau de Bord Admin',
    overview: 'Vue d\'ensemble et gestion',
    whatsapp: 'WhatsApp',
    liveSupport: 'Support en Direct',
    leadManagement: 'Gestion des Leads',
    blogManagement: 'Gestion du Blog',
    calendarView: 'Vue Calendrier',
    gtmSetup: 'Configuration GTM',
    totalBookings: 'Total Réservations',
    pending: 'En Attente',
    confirmed: 'Confirmé',
    cancelled: 'Annulé',
    patientResults: 'Résultats Patients',
    published: 'Publié',
    thisMonth: 'Ce Mois',
    newBookings: 'Nouvelles réservations',
    bookingTrend: 'Tendance Réservations (6 Derniers Mois)',
    monthlyStats: 'Statistiques mensuelles',
    bookingStatus: 'Statut Réservation',
    statusDistribution: 'Distribution par statut',
    popularTreatments: 'Traitements Populaires',
    topTreatments: 'Top 5 des traitements les plus demandés',
    patientResultsManagement: 'Gestion des Résultats Patients',
    manageBeforeAfter: 'Gérer les images avant/après et témoignages',
    addNewResult: 'Ajouter un Résultat',
    editResult: 'Modifier Résultat Patient',
    patientName: 'Nom du Patient',
    age: 'Âge',
    procedureType: 'Type de Procédure',
    graftsCount: 'Nombre de Greffons',
    surgeryDate: 'Date de Chirurgie',
    displayOrder: 'Ordre d\'Affichage',
    beforeImage: 'Image Avant',
    afterImage: 'Image Après',
    keepCurrentImage: 'Laisser vide pour conserver l\'image actuelle',
    testimonial: 'Témoignage',
    doctorNotes: 'Notes du Médecin',
    publishImmediately: 'Publier immédiatement',
    cancel: 'Annuler',
    uploading: 'Téléchargement...',
    update: 'Mettre à jour',
    create: 'Créer',
    unpublish: 'Dépublier',
    publish: 'Publier',
    draft: 'Brouillon',
    surgery: 'Chirurgie',
    order: 'Ordre',
    noResults: 'Aucun résultat patient. Ajoutez le premier!',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce résultat?',
    leads: 'Gestion des Leads',
    trackLeads: 'Suivez vos clients potentiels',
    downloadCSV: 'Télécharger CSV',
    totalLeads: 'Total Leads',
    hot: 'Chaud',
    warm: 'Tiède',
    cold: 'Froid',
    converted: 'Converti',
    sourceReport: 'Rapport Source',
    conversions: 'conversions',
    searchPlaceholder: 'Rechercher par email, téléphone ou nom...',
    allStatuses: 'Tous les Statuts',
    new: 'Nouveau',
    contacted: 'Contacté',
    qualified: 'Qualifié',
    lost: 'Perdu',
    allSources: 'Toutes les Sources',
    filterSource: 'Filtrer par source',
    leadList: 'Liste des Leads',
    loading: 'Chargement...',
    noLeads: 'Aucun lead trouvé',
    contact: 'Contact',
    source: 'Source',
    score: 'Score',
    activities: 'Activités',
    status: 'Statut',
    date: 'Date',
    actions: 'Actions',
    pageViews: 'Pages Vues',
    formSubmissions: 'Formulaires Soumis',
    pdfDownloads: 'PDF Téléchargés',
    chatInteractions: 'Interactions Chat',
    leadDetail: 'Détail du Lead',
    name: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    utmParams: 'Paramètres UTM',
    notes: 'Notes',
    saveNotes: 'Sauvegarder Notes',
    recentActivities: 'Activités Récentes',
    delete: 'Supprimer',
    deleteLeadConfirm: 'Êtes-vous sûr de vouloir supprimer ce lead?',
    initialEmail: 'Email Initial',
    followUpEmail: 'Email de Suivi',
    call: 'Appeler',
    manualEmail: 'Email Manuel',
    bookingsCalendar: 'Calendrier Réservations',
    viewManageAppointments: 'Voir et gérer tous les rendez-vous',
    sendReminders: 'Envoyer Rappels',
    searchByNameEmailPhone: 'Rechercher par nom, email ou téléphone...',
    filterByStatus: 'Filtrer par statut',
    allTreatments: 'Tous les Traitements',
    clearFilters: 'Effacer Filtres',
    today: 'Aujourd\'hui',
    more: 'plus',
    selectDate: 'Sélectionner une date',
    noBookingsForDate: 'Aucune réservation pour cette date',
    clickToView: 'Cliquez sur une date pour voir les réservations',
    reminded: 'Rappelé',
    confirm: 'Confirmer',
    accessDenied: 'Accès Refusé',
    needAdminAccess: 'Vous devez avoir des privilèges admin pour accéder à cette page.',
    goHome: 'Accueil',
    galleryManagement: 'Gestion Galerie',
    backToGallery: 'Retour à la Galerie',
    uploadNewPhoto: 'Télécharger Nouvelle Photo',
    title: 'Titre',
    description: 'Description',
    altText: 'Texte Alt (important pour SEO)',
    treatmentPage: 'Page Traitement (Optionnel)',
    selectTreatment: 'Sélectionner un traitement (peut être vide)',
    treatmentNote: 'Sélectionnez un traitement pour afficher cette photo sur cette page.',
    photo: 'Photo',
    upload: 'Télécharger',
    uploadedPhotos: 'Photos Téléchargées',
    removeFromPublish: 'Dépublier',
    generalGallery: 'Galerie Générale (Sans traitement)',
    emailTemplates: 'Modèles Email',
    manageEmailTemplates: 'Gérer les modèles email automatiques',
    newTemplate: 'Nouveau Modèle',
    templateKey: 'Clé',
    active: 'Actif',
    preview: 'Aperçu',
    edit: 'Modifier',
    editTemplate: 'Modifier Modèle',
    templateName: 'Nom du Modèle',
    emailSubject: 'Sujet Email',
    htmlContent: 'Contenu HTML',
    variablesNote: 'Variables: {{name}}, {{email}} peuvent être utilisées',
    save: 'Sauvegarder',
    close: 'Fermer',
    createTemplate: 'Créer Modèle',
    templateKeyUnique: 'Clé du Modèle (unique)',
    cms: 'Gestion de Contenu',
    posts: 'Articles',
    pages: 'Pages',
    media: 'Médias',
    categories: 'Catégories',
    settings: 'Paramètres',
  },
  hairAnalysis: {
    title: "Analyse Capillaire IA",
    subtitle: "Téléchargez votre photo pour une évaluation préliminaire basée sur l'IA. Il s'agit d'un outil de dépistage initial qui ne remplace pas une consultation avec un clinicien qualifié.",
    uploadPhoto: "Télécharger une Photo",
    uploadPhotoDesc: "Téléchargez une photo claire de vos cheveux pour l'analyse",
    clickToUpload: "Cliquez pour télécharger l'image",
    analyzeNow: "Analyser Maintenant",
    analyzing: "Analyse en cours...",
    analysisResults: "Résultats d'Analyse",
    hairLossStage: "Stade de Perte de Cheveux",
    estimatedGrafts: "Greffons Estimés",
    recommendedTreatment: "Traitement Recommandé",
    recommendations: "Recommandations",
    detailedAnalysis: "Analyse Détaillée",
    howItWorks: "Comment Ça Marche",
    step1: "Téléchargez une photo claire de face de vos cheveux",
    step2: "Notre IA analyse votre densité capillaire et votre modèle de perte",
    step3: "Recevez une évaluation instantanée avec des recommandations de traitement",
    step4: "Réservez une consultation avec nos spécialistes pour une planification détaillée",
    priceEstimate: "Prix Estimé",
    pricePerGraft: "Prix par greffon",
    priceNote: "* Le prix final sera déterminé lors de la consultation",
    priceRange: 'Fourchette de Prix Estimée',
    bookViaWhatsApp: 'Réserver via WhatsApp',
    whatsappMessage: 'Consultation WhatsApp',
    getDetailedReport: 'Obtenir un Rapport PDF Détaillé',
    reportDescription: 'Recevez un rapport d\'analyse complet avec recommandations de traitement par email',
    yourName: 'Votre Nom',
    yourEmail: 'Votre Email',
    enterName: 'Entrez votre nom',
    enterEmail: 'Entrez votre adresse email',
    sendReport: 'Envoyer le Rapport par Email',
    sending: 'Envoi en cours...',
    reportDisclaimer: 'Rapport PDF détaillé gratuit avec plan de traitement et tarifs',
    shareResults: 'Partagez Vos Résultats',
    shareDescription: 'Partagez vos résultats d\'analyse avec vos amis et votre famille',
    shareNote: '* Instagram : Le texte sera copié dans le presse-papiers',
  },
  auth: {
    seoTitle: 'Connexion & Inscription - Portail Patient | Hair Art Clinics',
    seoDescription: 'Accédez au portail patient Hair Art Clinics. Connectez-vous pour consulter vos dossiers médicaux, photos de traitement et gérer vos rendez-vous.',
    welcome: 'Bienvenue',
    welcomeSubtitle: 'Connectez-vous pour accéder au portail patient ou créez un nouveau compte',
    forgotTitle: 'Mot de passe oublié',
    forgotSubtitle: 'Entrez votre e-mail pour recevoir un lien de réinitialisation',
    resetTitle: 'Réinitialiser le mot de passe',
    resetSubtitle: 'Entrez votre nouveau mot de passe',
    login: 'Connexion',
    signup: 'Inscription',
    email: 'E-mail',
    password: 'Mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    fullName: 'Nom complet',
    signIn: 'Se connecter',
    createAccount: 'Créer un compte',
    updatePassword: 'Mettre à jour le mot de passe',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    backToLogin: 'Retour à la connexion',
    orContinueWith: 'Ou continuer avec',
    continueWithGoogle: 'Continuer avec Google',
    forgotYourPassword: 'Mot de passe oublié ?',
  },
  clinic: {
    city: 'La Haye (Den Haag)',
    country: 'Pays-Bas',
    region: 'Hollande-Méridionale',
    hoursLabel: 'Heures d’ouverture',
    hoursDaily: 'Tous les jours',
  },
};
